'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

function fail() {
  throw new Error('Key management requires \'--pass ...\' option');
}

var NoKeychain =
/*#__PURE__*/
function () {
  function NoKeychain() {
    _classCallCheck(this, NoKeychain);
  }

  _createClass(NoKeychain, [{
    key: "createKey",
    value: function createKey() {
      fail();
    }
  }, {
    key: "listKeys",
    value: function listKeys() {
      fail();
    }
  }, {
    key: "findKeyById",
    value: function findKeyById() {
      fail();
    }
  }, {
    key: "findKeyByName",
    value: function findKeyByName() {
      fail();
    }
  }, {
    key: "renameKey",
    value: function renameKey() {
      fail();
    }
  }, {
    key: "removeKey",
    value: function removeKey() {
      fail();
    }
  }, {
    key: "exportKey",
    value: function exportKey() {
      fail();
    }
  }, {
    key: "importKey",
    value: function importKey() {
      fail();
    }
  }, {
    key: "importPeer",
    value: function importPeer() {
      fail();
    }
  }, {
    key: "cms",
    get: function get() {
      fail();
    }
  }], [{
    key: "generateOptions",
    value: function generateOptions() {
      fail();
    }
  }, {
    key: "options",
    get: function get() {
      fail();
    }
  }]);

  return NoKeychain;
}();

module.exports = NoKeychain;